"use client";

import {
	createContext,
	useContext,
	useEffect,
	useState,
	type ReactNode,
} from "react";

import { useAppConfig } from "@/lib/config";

export interface Edition {
	edition: "enterprise" | "b2c";
	selfServeBilling: boolean;
	publicSignup: boolean;
	loading: boolean;
}

const DEFAULT: Edition = {
	edition: "b2c",
	selfServeBilling: true,
	publicSignup: true,
	loading: true,
};

const EditionContext = createContext<Edition>(DEFAULT);

export function EditionProvider({ children }: { children: ReactNode }) {
	const config = useAppConfig();
	const [state, setState] = useState<Edition>(DEFAULT);

	useEffect(() => {
		let cancelled = false;
		fetch(`${config.apiUrl}/admin/edition`, { credentials: "include" })
			.then((r) => (r.ok ? r.json() : null))
			.then((d) => {
				if (cancelled || !d) {
					if (!cancelled) {
						setState((s) => ({ ...s, loading: false }));
					}
					return;
				}
				setState({
					edition: d.edition,
					selfServeBilling: !!d.selfServeBilling,
					publicSignup: !!d.publicSignup,
					loading: false,
				});
			})
			.catch(() => setState((s) => ({ ...s, loading: false })));
		return () => {
			cancelled = true;
		};
	}, [config.apiUrl]);

	return (
		<EditionContext.Provider value={state}>{children}</EditionContext.Provider>
	);
}

export function useEdition(): Edition {
	return useContext(EditionContext);
}
